import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Globe } from "lucide-react";
import { BRAND } from "../lib/data";
import { brochureUrl } from "../lib/api";

export default function Footer() {
  return (
    <footer className="glass-footer text-white" data-testid="site-footer">
      <img src={BRAND.watermark} alt="" aria-hidden="true" className="footer-watermark" data-testid="footer-watermark" />
      <div className="container-x relative py-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="bg-white rounded-sm p-3 inline-block mb-4">
            <img src={BRAND.logo} alt={BRAND.logoAlt} className="h-14 w-auto object-contain" />
          </div>
          <p className="text-sm text-white/70 leading-relaxed">
            Connecting businesses with the right financiers. High-ticket funding & complex financial solutions across Pan-India.
          </p>
        </div>

        <div>
          <h4 className="font-heading font-semibold mb-4 text-sm uppercase tracking-wider">Company</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/about" className="hover:text-brandred" data-testid="footer-about">About Us</Link></li>
            <li><Link to="/services" className="hover:text-brandred" data-testid="footer-services">Services</Link></li>
            <li><Link to="/contact" className="hover:text-brandred" data-testid="footer-contact">Contact</Link></li>
            <li><a href={brochureUrl} target="_blank" rel="noopener noreferrer" className="hover:text-brandred" data-testid="footer-brochure">Download Brochure</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold mb-4 text-sm uppercase tracking-wider">Legal</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/terms" className="hover:text-brandred" data-testid="footer-terms">Terms & Conditions</Link></li>
            <li><Link to="/privacy" className="hover:text-brandred" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/disclaimer" className="hover:text-brandred" data-testid="footer-disclaimer">Disclaimer</Link></li>
            <li><Link to="/admin" className="hover:text-brandred" data-testid="footer-admin">Admin Login</Link></li>
          </ul>
        </div>

        <div className="min-w-0">
          <h4 className="font-heading font-semibold mb-4 text-sm uppercase tracking-wider">Reach Us</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5 text-brandred shrink-0" /><a href={`tel:${BRAND.phone}`} className="hover:text-brandred" data-testid="footer-phone">{BRAND.phoneDisplay}</a></li>
            <li className="flex items-start gap-2 min-w-0"><Mail size={16} className="mt-0.5 text-brandred shrink-0" /><a href={`mailto:${BRAND.email}`} className="hover:text-brandred break-all" data-testid="footer-email">{BRAND.email}</a></li>
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5 text-brandred shrink-0" /><span className="break-words" data-testid="footer-address">{BRAND.address}</span></li>
            <li className="flex items-start gap-2 min-w-0"><Globe size={16} className="mt-0.5 text-brandred shrink-0" /><span className="break-all" data-testid="footer-website">{BRAND.website}</span></li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="container-x py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-white/60">
          <span>© {new Date().getFullYear()} Crew Connect FinInvesto. All rights reserved.</span>
          <span>"Don't let rejection stop your growth. Call for a Free Consultation!"</span>
        </div>
      </div>
    </footer>
  );
}
